import React, { Component } from "react";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import $, { data } from "jquery";
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class StsLogs extends Component {
  constructor() {
    super();

    this.state = {
      showAudioPlayer: false,
      selectedRowId: "",
      utteranceDisplayName: "",
      startDate: new Date(),
      selectedDate: new Date(),
      escalatedChecked: false,
      attendedChecked: false,
      unattendedChecked: false,
      data: [
        {
          id: "",
          text: "",
          userId: "",
          valueType: "",
          description: "",
          valueType: [],
          userId: "",
          displayName: "",
          contactNumber: "",
          preferredLanguage: "",
          escalated: "",
          attendedChecked: "",
          unattendedChecked: "",
          date: "",
          conversationId: "",
          deleteRow: false,
        },
      ],
      utData: [],
      disabled: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      showStore: false,
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      queryMobileNumber: null,
    };
    this.editImageSrc = "./assets/images/edit.svg";
    this.saveImageSrc = "./assets/images/save.svg";

    this.valueTypeVar = [];
  }

  notifyFailToCreate() {
    toast(
      <b style={{ color: "red" }}>Oops! Error occurred. \n Please try again</b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  }

  notifyInvalidMobileNumber() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please enter a valid mobile number
      </b>,
      {
        position: "top-center",
      }
    );
  }

  componentDidMount() {
    var thisController = this;
    var selectedDate = this.state.selectedDate;
    setTimeout(() => {
      thisController.state.utData = [];
      thisController.state.queryMobileNumber = null;
      thisController.setState(thisController.state);
      thisController.fetchConversationLogData(selectedDate);
    }, 300);

    document.addEventListener("projectChanged", function (event) {
      var selectedDate = thisController.state.selectedDate;
      thisController.state.utData = [];
      thisController.state.queryMobileNumber = null;
      thisController.setState(thisController.state);
      thisController.projectId = event.projectId;
      thisController.fetchConversationLogData(selectedDate, event.projectId);
    });
  }

  escalatedChecked = (e) => {
    var conversationLogController = this;
    conversationLogController.state.escalatedChecked = e.target.checked;
    if (!conversationLogController.state.escalatedChecked) {
      conversationLogController.state.attendedChecked = false;
      conversationLogController.state.unattendedChecked = false;
    }
    conversationLogController.state.utData = [];
    conversationLogController.setState(conversationLogController.state);
    var selectedDate = conversationLogController.state.selectedDate;
    conversationLogController.fetchConversationLogData(selectedDate);
  };
  attendedChecked = (e) => {
    var conversationLogController = this;
    conversationLogController.state.attendedChecked = true;
    conversationLogController.state.unattendedChecked = false;
    conversationLogController.state.utData = [];
    conversationLogController.setState(conversationLogController.state);
    var selectedDate = conversationLogController.state.selectedDate;
    conversationLogController.fetchConversationLogData(selectedDate);
  };
  unattendedChecked = (e) => {
    var conversationLogController = this;
    conversationLogController.state.unattendedChecked = true;
    conversationLogController.state.attendedChecked = false;
    conversationLogController.state.utData = [];
    conversationLogController.setState(conversationLogController.state);
    var selectedDate = conversationLogController.state.selectedDate;
    conversationLogController.fetchConversationLogData(selectedDate);
  };
  refreshData = () => {
    var conversationController = this;
    conversationController.state.selectedDate = new Date();
    conversationController.state.utData = [];
    conversationController.setState(conversationController.state);
    conversationController.fetchConversationLogData(
      conversationController.state.selectedDate
    );
  };
  onChange = (date) => {
    this.state.selectedDate = date;
    this.state.utData = [];
    this.setState(this.state);
    this.fetchConversationLogData(date);
  };

  fetchConversationLogData = (selectedDate, projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    let conversationController = this;
    let longDate = new Date(selectedDate.toDateString()).getTime();

    let data = {};
    data.projectId = projectId;
    data.date = longDate;

    $.ajax({
      url: "/api/paribhasha-conversations",
      async: false,
      method: "GET",
      data: data,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          var tagKeys = res.result;
          conversationController.setState({
            data: tagKeys,
            successResp: true,
          });
        }
      },
    });
  };

  fetchUtterancesApi = (id) => {
    var utteranceController = this;

    $.ajax({
      url: "/api/paribhasha-utterances",
      async: false,
      method: "GET",
      data: { paribhashaSessionId: id },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          var data = res.result;
          // for (var i = 0; i < res.result.length; i++) {
          //   data[i] = Object.assign(res.result[i], source);
          //   if (res.result[i].id == id) {
          //     data[i] = Object.assign(res.result[i], source);
          //   }
          // }
          utteranceController.setState({
            utData: data,
            successResp: true,
          });
        } else {
          utteranceController.notifyFailToCreate();
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  };
  handleChange = (e) => {
    this.setState({ selectValue: e.target.value });
  };
  handleChangeForUtterance = (id) => {
    var showAudioPlayer = true;
    // if (uxType === "TELEPHONY") {
    //   showAudioPlayer = true;
    //   var audioPlayer = document.getElementById("callRecordingPlayer");
    //   var audioUrl =
    //     window.location.protocol +
    //     "//" +
    //     window.location.host +
    //     "/api/get-call-recording/" +
    //     id +
    //     ".mp3";
    //   audioPlayer.src = audioUrl;
    //   audioPlayer.load();
    // }
    this.setState({
      selectedRowId: id,
      text: this.state.value,
      showAudioPlayer: showAudioPlayer,
    });

    this.fetchUtterancesApi(id);
  };

  queryHandleChange = (e) => {
    let mobileNumber = document.getElementById("query-mobile-number").value;
    console.log("Entered mobile number: " + mobileNumber);
    if (this.validateMobileNumber(mobileNumber)) {
      this.state.queryMobileNumber = mobileNumber;
      this.setState(this.state);
      this.fetchConversationLogData(this.state.selectedDate);
    } else {
      this.notifyInvalidMobileNumber();
    }
  };

  validateMobileNumber = (number) => {
    return /^\+?\d+$/.test(number);
  };

  render() {
    const { data } = this.state;
    // const paribhashaSessions = [
    //   {
    //     id: "a74c7dc7-9d7b-42f5-bf33-5c9a4e45673d",
    //     projectId: "d63f2c19-53bb-4f96-b91a-9e4b5b7a58c8",
    //     startTime: 1672531200000,
    //     endTime: 1672534800000,
    //     deviceId: "f14b8d73-2c5e-498e-88b5-8f50cf9a42b1",
    //     initParams: '{"voiceRate": 1.2, "volume": 0.8}',
    //     inputLanguage: "ENGLISH",
    //     outputLanguage: "SPANISH",
    //     voiceGender: "FEMALE",
    //     ipAddress: "192.168.1.1",
    //     lat: "37.7749",
    //     longt: "-122.4194",
    //     timeZone: "PST",
    //     locale: "en_US",
    //     initMode: "AUTOMATIC",
    //     initIntent: "greeting",
    //     developerId: "ecb68d2e-1547-437e-8e36-94a07f5a94d6",
    //     voiceServerName: "VoiceServerAlpha",
    //     voiceServerIpAddress: "192.168.1.2",
    //     voiceHandleId: "f16b7e93-4b7c-4af8-aab9-67a4e52cfe14",
    //   },
    //   {
    //     id: "bd5b4d2b-92de-4e96-b9b2-6d7a5e7b5a19",
    //     projectId: "cb96e814-3a76-42e1-8d21-719b4efb295c",
    //     startTime: 1672538400000,
    //     endTime: 1672542000000,
    //     deviceId: "a94b5d82-3d7a-48b3-b8c2-5c9e1e9f4b16",
    //     initParams: '{"voiceRate": 1.0, "volume": 1.0}',
    //     inputLanguage: "FRENCH",
    //     outputLanguage: "GERMAN",
    //     voiceGender: "MALE",
    //     ipAddress: "192.168.1.3",
    //     lat: "48.8566",
    //     longt: "2.3522",
    //     timeZone: "CET",
    //     locale: "fr_FR",
    //     initMode: "MANUAL",
    //     initIntent: "translate",
    //     developerId: "e5d7b3d6-2c5b-49e8-b9c5-9f4e7b1d5c14",
    //     voiceServerName: "VoiceServerBeta",
    //     voiceServerIpAddress: "192.168.1.4",
    //     voiceHandleId: "c2b7e9b6-3a7e-47d8-b9c2-4f9b3e7b4c19",
    //   },
    // ];

    // const paribhashaUtterances = [
    //   {
    //     id: "c6a4b2e5-9b7d-43f5-bc5e-8f3a4e5b7c2a",
    //     projectId: "d63f2c19-53bb-4f96-b91a-9e4b5b7a58c8",
    //     englishText: "Hello, how are you?",
    //     spokenText: "Hola, ¿cómo estás?",
    //     sourceLanguage: "ENGLISH",
    //     targetLanguage: "SPANISH",
    //     audioFileUrl: "https://example.com/audio/utterance1.mp3",
    //     paribhashaSessionId: "a74c7dc7-9d7b-42f5-bf33-5c9a4e45673d",
    //   },
    //   {
    //     id: "b7d6e9c4-2a5b-49f8-b9c3-5d7a6e4b8c1a",
    //     projectId: "cb96e814-3a76-42e1-8d21-719b4efb295c",
    //     englishText: "Good morning, what's the weather like?",
    //     spokenText: "Bonjour, quel temps fait-il?",
    //     sourceLanguage: "ENGLISH",
    //     targetLanguage: "FRENCH",
    //     audioFileUrl: "https://example.com/audio/utterance2.mp3",
    //     paribhashaSessionId: "bd5b4d2b-92de-4e96-b9b2-6d7a5e7b5a19",
    //   },
    // ];

    

    const columns1 = [
      {
        // width: 250,
        Header: "",
        minWidth: 17,
        textAlign: "screenLeft",
        accessor: "id",
        sortable: false,
        cellStyle: { border: "none", padding: "5px" },
        headerStyle: { marginTop: "-10px" },
        Cell: (props) => (
          <div
            style={{
              borderRadius: "15px",
              padding: "16px",
              margin: "10px 0",
              backgroundColor: "#e1e1f5",
              wordWrap: "break-word",
              overflowWrap: "break-word",
            }}
          >
            <div style={{ marginBottom: "8px", display: "flex" }}>
              <b>English Text:</b>
              <span
                style={{
                  display: "inline-block",
                  whiteSpace: "normal",
                  marginLeft: "8px",
                }}
              >
                {props.original.englishText}
              </span>
            </div>
            <div style={{ marginBottom: "8px", display: "flex" }}>
              <b>Spoken Text:</b>
              <span
                style={{
                  display: "inline-block",
                  whiteSpace: "normal",
                  marginLeft: "8px",
                }}
              >
                {props.original.spokenText}
              </span>
            </div>
            <div style={{ marginBottom: "4px" }}>
              <b>Source Language:</b>
              <span style={{ marginLeft: "4px" }}>
                {props.original.sourceLanguage}
              </span>
            </div>
            <div style={{ marginBottom: "4px" }}>
              <b>Target Language:</b>
              <span style={{ marginLeft: "4px" }}>
                {props.original.targetLanguage}
              </span>
            </div>
            {props.original.audioFileUrl && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <audio controls style={{ flexGrow: 1, height: "3rem" }}>
                  <source src={props.original.audioFileUrl} type="audio/mp3" />
                </audio>
                <a
                  href={props.original.audioFileUrl}
                  download
                  style={{
                    textDecoration: "none",
                    color: "#fff",
                    backgroundColor: "#282a65",
                    padding: "8px 16px",
                    borderRadius: "5px",
                  }}
                >
                  <img
                    src="./assets/images/download-2-white.png"
                    style={{ width: "1.5rem", height: "1.5rem" }}
                  />
                </a>
              </div>
            )}
          </div>
        ),
      },
    ];

    const columns = [
      {
        Header: "Id",
        accessor: "id",
        show: false,
        Cell: (props) => (
          <div name="id" id={"id" + props.index}>
            {props.original.id}
          </div>
        ),
      },

      {
        Header: () => "",
        accessor: "id",
        sortable: false,
        headerStyle: { marginTop: "-10px" },
        Cell: (props) => (
          <div
            name="userId"
            className={
              this.state.selectedRowId == props.original.id
                ? "selectedConvEntryInLog"
                : ""
            }
            style={{ borderBottom: "0.5px solid" }}
          >
            <b>Input Language :</b>
            <font
              style={{
                color: "none",
                border: "none",
                background: "white",
                resize: "none",
                marginLeft: "5px",
                marginRight: "20px",
              }}
              id={"displayName" + props.index}
            >
              {props.original.inputLanguage}
            </font>
            <b>Output Language :</b>
            <font
              style={{
                color: "none",
                border: "none",
                background: "white",
                resize: "none",
                marginLeft: "5px",
                marginRight: "20px",
              }}
              id={"displayName" + props.index}
            >
              {props.original.outputLanguage}
            </font>
            <b>Start Time :</b>
            <font
              style={{
                color: "none",
                border: "none",
                background: "white",
                resize: "none",
                marginLeft: "5px",
              }}
              id={"displayName" + props.index}
            >
              {new Date(props.original.startTime).toLocaleString()}
            </font>
            <br />
            <b>VoiceServer Name :</b>
            <font
              style={{
                border: "none",
                background: "white",
                resize: "none",
                marginLeft: "5px",
                marginRight: "20px",
              }}
              id={"contactNumber" + props.index}
            >
              {props.original.voiceServerName}
            </font>
            <b>Init Intent :</b>
            <font
              style={{
                border: "none",
                background: "white",
                resize: "none",
                marginLeft: "6px",
                marginRight: "25px",
              }}
              id={"preferredLanguage" + props.index}
            >
              {props.original.initIntent}
            </font>

            <b>Voice Gender : </b>
            <font
              style={{
                border: "none",
                background: "white",
                resize: "none",
                marginLeft: "6px",
                marginRight: "25px",
              }}
              id={"escalationChecked" + props.index}
            >
              {props.original.voiceGender}
            </font>
            <br />
            <b>Location Lat:</b>
            <font
              style={{
                border: "none",
                background: "white",
                resize: "none",
                marginLeft: "6px",
                marginRight: "25px",
              }}
              id={"latitude" + props.index}
            >
              {props.original.lat == null ? "NA" : props.original.lat}
            </font>
            <b>Location Longt:</b>
            <font
              style={{
                border: "none",
                background: "white",
                resize: "none",
                marginLeft: "6px",
                marginRight: "25px",
              }}
              id={"longitude" + props.index}
            >
              {props.original.longt == null ? "NA" : props.original.longt}
            </font>
            <br />
            <div Align="right">
              <button
                className="btn2 table-action-button "
                title="View conversation"
                style={{ borderRadius: "4px" }}
                onClick={() => {
                  this.handleChangeForUtterance(props.original.id);
                }}
              >
                View utterances
              </button>
            </div>
          </div>
        ),
      },
      {
        Header: () => "userId",
        accessor: "userId",
        sortable: false,

        show: false,
        Cell: (props) => (
          <div name="userId">
            <textarea
              style={{ border: "none", background: "white", resize: "none" }}
              id={"userId" + props.index}
              class="form-control"
              rows="1"
              maxlength="250"
              readOnly={
                props.original.id != ""
                  ? props.original.id != this.state.editedId
                  : false
              }
            >
              {props.original.userId}
            </textarea>
          </div>
        ),
      },
      {
        Header: () => "displayName",
        accessor: "displayName",
        sortable: false,

        show: false,
        Cell: (props) => (
          <div name="displayName">
            <textarea
              style={{ border: "none", background: "white", resize: "none" }}
              id={"displayName" + props.index}
              class="form-control"
              rows="1"
              maxlength="250"
              readOnly={
                props.original.id != ""
                  ? props.original.id != this.state.editedId
                  : false
              }
            >
              {props.original.displayName}
            </textarea>
          </div>
        ),
      },

      {
        Header: () => "contactNumber",
        accessor: "displayName",
        sortable: false,

        show: false,
        Cell: (props) => (
          <div name="displayName">
            <textarea
              style={{ border: "none", background: "white", resize: "none" }}
              id={"displayName" + props.index}
              class="form-control"
              rows="1"
              maxlength="250"
              readOnly={
                props.original.id != ""
                  ? props.original.id != this.state.editedId
                  : false
              }
            >
              {props.original.displayName}
            </textarea>
          </div>
        ),
      },

      {
        Header: () => "preferredLanguage",
        accessor: "displayName",
        sortable: false,

        show: false,
        Cell: (props) => (
          <div name="displayName">
            <textarea
              style={{ border: "none", background: "white", resize: "none" }}
              id={"displayName" + props.index}
              class="form-control"
              rows="1"
              maxlength="250"
              readOnly={
                props.original.id != ""
                  ? props.original.id != this.state.editedId
                  : false
              }
            >
              {props.original.displayName}
            </textarea>
          </div>
        ),
      },

      {
        Header: () => "escalationChecked",
        accessor: "displayName",
        sortable: false,

        show: false,
        Cell: (props) => (
          <div name="displayName">
            <textarea
              style={{ border: "none", background: "white", resize: "none" }}
              id={"displayName" + props.index}
              class="form-control"
              rows="1"
              maxlength="250"
              readOnly={
                props.original.id != ""
                  ? props.original.id != this.state.editedId
                  : false
              }
            >
              {props.original.displayName}
            </textarea>
          </div>
        ),
      },

      {
        Header: () => "attendedChecked",
        accessor: "attendedChecked",
        sortable: false,

        show: false,
        Cell: (props) => (
          <div name="attendedChecked">
            <textarea
              style={{ border: "none", background: "white", resize: "none" }}
              id={"attendedChecked" + props.index}
              class="form-control"
              rows="1"
              maxlength="250"
              readOnly={
                props.original.id != ""
                  ? props.original.id != this.state.editedId
                  : false
              }
            >
              {props.original.attendedChecked}
            </textarea>
          </div>
        ),
      },

      {
        Header: () => "date",
        accessor: "date",
        sortable: false,

        show: false,
        Cell: (props) => (
          <div name="date">
            <textarea
              style={{ border: "none", background: "white", resize: "none" }}
              id={"date" + props.index}
              class="form-control"
              rows="1"
              maxlength="250"
              readOnly={
                props.original.id != ""
                  ? props.original.id != this.state.editedId
                  : false
              }
            >
              {props.original.date}
            </textarea>
          </div>
        ),
      },
      {
        Header: () => "conversationId",
        accessor: "conversationId",
        sortable: false,

        show: false,
        Cell: (props) => (
          <div name="conversationId">
            <textarea
              style={{ border: "none", background: "white", resize: "none" }}
              id={"conversationId" + props.index}
              class="form-control"
              rows="1"
              maxlength="250"
              readOnly={
                props.original.id != ""
                  ? props.original.id != this.state.editedId
                  : false
              }
            >
              {props.original.conversationId}
            </textarea>
          </div>
        ),
      },
    ];

    return (
      <div visible={this.state.successResp ? false : true}>
        <div
          style={{
            background: "#F9F9FB",
            marginLeft: "1%",
            marginRight: "1%",
          }}
        >
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          {/* for reactTable */}
          <link
            rel="stylesheet"
            href="assets/css/React_Table_CSS/react-table.css"
          />
          <link rel="stylesheet" href="./assets/css/react.table.border.css" />
          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          {/* <div className="wrapper"> */}
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <title> Dheeyantra | BackEnd Api </title>
          {/* Font Awesome Icons */}
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          {/* IonIcons */}
          <link
            rel="stylesheet"
            href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link
            href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
            rel="stylesheet"
          />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          {/* ----new style------------------------------- */}
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          <link
            rel="stylesheet"
            href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
          />
          <link
            href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
            rel="stylesheet"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="dist/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <style
            media="screen"
            dangerouslySetInnerHTML={{
              __html:
                "\n    .card-footer {\n      background-color: transparent;\n      padding: 0.75rem 0.25rem;\n    }\n\n    .logtable tbody td:last-child{\n      width: 150px;\n    }\n\n    .logTableBox{\n      overflow: auto !important;\n    }\n  ",
            }}
          />

          {/* for checkbox component */}
          <link rel="stylesheet" href="./assets/css/combobox-style.css" />
          <link
            rel="stylesheet"
            href="assets/css/Checkbox/Checkboxbutton.css"
          />
          <link rel="stylesheet" href="assets/css/Checkbox/CheckboxTick.css" />

          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-5">
                <h1 className="m-0 page-title">Reports</h1>
              </div>
            </div>
            <div className="row" style={{ marginTop: "1%" }}>
              <div className="col-sm-4">
                <h6
                  className="nav-item"
                  style={{ color: "#282a65", marginTop: "0%" }}
                >
                  Speech Translation Logs
                </h6>
                <h6></h6>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "2rem",
                marginBottom: "1%",
              }}
            >
              {/* Date picker */}
              <div className="col-sm-3" style={{ marginLeft: "0%" }}>
                <div className="p" style={{ cursor: "pointer" }}>
                  <b>
                    DATE :{" "}
                    <DatePicker
                      style={{
                        width: "20px",
                        marginLeft: "70%",
                        cursor: "pointer",
                      }}
                      id="date"
                      selected={this.state.selectedDate}
                      onChange={this.onChange}
                      dateFormat="dd/MM/yyyy"
                    ></DatePicker>
                  </b>
                </div>
              </div>

              {/* Audio controllers */}
              {/* <div
                style={{
                  display: this.state.showAudioPlayer ? "flex" : "none",
                  alignItems: "center",
                  gap: "1rem",
                  borderRadius: "10px",
                  margin: "10px",
                  padding: "6px",
                  height: "auto",
                  textAlign: "center",
                  marginLeft: "-7rem",
                }}
              >
                <audio
                  id="callRecordingPlayer"
                  controlsList="nofullscreen"
                  controls
                  style={{ width: "20vw" }}
                >
                  <source src="" type="audio/mpeg" />
                </audio>

                <a
                  href={`${window.location.protocol}//${window.location.host}/api/download-call-recording?conversationId=${this.state.selectedRowId}`}
                  target="_blank"
                  style={{
                    padding: "1rem",
                    color: "white",
                    display: "flex",
                    gap: "11px",
                    backgroundColor: "#282a65",
                    borderRadius: "10px",
                  }}
                >
                  <img
                    src="./assets/images/download-2-white.png"
                    style={{ width: "1.5rem", height: "1.5rem" }}
                  />

                  <span>Download Audio</span>
                </a>
              </div> */}
            </div>
          </div>
          {/* /.content-header */}
          <div className="content" style={{ marginTop: "10px" }}>
            <div className="container-fluid">
              <div className="row" style={{ marginRight: "2%" }}>
                <ToastContainer classname="Toast-at-center" />
                <div className="col-lg-6">
                  <div
                    className="card"
                    style={{
                      height: "570px",
                      overflowY: data.length > 4 ? "scroll" : "hidden",
                    }}
                  >
                    <div>
                      <ReactTable
                        style={{
                          display: this.state.successResp ? "block" : "none",
                        }}
                        data={this.state.data}
                        columns={columns}
                        pageSize={data.length > 5 ? data.length : 5}
                        showPagination={false}
                      />
                    </div>
                  </div>
                  {/* <ToastContainer classname="Toast-at-center" /> */}
                </div>
                <div></div>
                <div class="col-lg-6">
                  <div
                    className="card"
                    style={{ height: "570px", overflowY: "auto" }}
                  >
                    <div class="table-responsive logTableBox">
                      <ReactTable
                        id="reactTable"
                        data={this.state.utData}
                        columns={columns1}
                        showPagination={false}
                        pageSize={
                          this.state.utData.length <= 5
                            ? 5
                            : this.state.utData.length
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default StsLogs;



// WEBPACK FOOTER //
// ./src/stsUi/Reports.js